import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/common/PageHeader';
import PatientForm from '../components/patient/PatientForm';
import PatientSearch from '../components/common/PatientSearch';
import { patientApi, visitApi } from '../api';
import { useToast } from '../context/ToastContext';

export default function NewPatient() {
  const navigate = useNavigate();
  const toast = useToast();

  async function handleSubmit(values, vitals) {
    let patient;
    try {
      const res = await patientApi.create(values);
      patient = res.data;
    } catch (err) {
      toast.error(err);
      throw err;
    }

    // Registering is also sending the patient in - one click does both. The fee
    // comes from Clinic Settings and is collected at the desk afterwards.
    try {
      const res = await visitApi.create({
        patient: patient._id,
        vitals: { ...vitals, ...(values.weight ? { weight: values.weight } : {}) },
      });
      toast.success(`${patient.name} registered as ${patient.patientId} and queued on token ${res.data.tokenNo}`);
      navigate('/queue');
    } catch (err) {
      // The patient is saved either way, so send reception to the record rather
      // than lose everything they just typed.
      toast.warn(`${patient.name} was registered, but could not be queued: ${err.message}`);
      navigate(`/patients/${patient._id}`);
    }
  }

  return (
    <>
      <PageHeader
        title="Register New Patient"
        subtitle="Fill this only for someone visiting for the first time"
        icon="bi-person-plus-fill"
      >
        <Button variant="light" onClick={() => navigate('/queue')}>
          <i className="bi bi-arrow-left me-1" /> Back to Queue
        </Button>
      </PageHeader>

      <Alert variant="info" className="d-flex flex-column flex-md-row align-items-md-center gap-2">
        <div className="flex-shrink-0">
          <i className="bi bi-info-circle me-1" />
          <strong>Already been here before?</strong> Search instead of registering again:
        </div>
        <div className="flex-grow-1" style={{ minWidth: 260 }}>
          <PatientSearch onSelect={(p) => navigate(`/patients/${p._id}`)} placeholder="Search existing patient..." />
        </div>
      </Alert>

      <PatientForm
        showVitals
        onSubmit={handleSubmit}
        onPickExisting={(p) => navigate(`/patients/${p._id}`)}
        submitLabel="Register & Send to Doctor"
      />
    </>
  );
}
